import React from "react";
import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import { Dialog, DialogContent, Stack, Typography, Box } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Loader from "../components/Loader";
import SearchIcon from "@mui/icons-material/Search";
import { useState } from "react";
import Repo from "../../Repository/Repo";
import { Toast } from "../components/Toast";

function SearchItems({ onClose, onSelect }) {
  const [searchItems, setSearchItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const getSearchItems = async () => {
    setLoading(true);
    let { data } = await Repo.default({
      request: {
        method: "getSearchItems",
        data: {
          company_code: localStorage.getItem("companyCode"),
          search_item: searchText,
          vendor: "",
        },
      },
    });
    let res = data.response.data.items;
    setLoading(false);
    // itemToggle();
    // console.log("data", data);
    if (res.length > 0) {
      setSearchItems(res);
    } else {
      Toast("info", "No Items Found");
    }
  };
  const handleSearch = (e) => {
    const { value } = e.target;
    setSearchText(value);
  };
  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack spacing={2}>
          <Stack
            direction="row"
            width="100%"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              Search Items
            </Typography>
            <HighlightOffIcon onClick={onClose} sx={{ cursor: "pointer" }} />
          </Stack>
          {!loading && (
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label="Search items..."
              value={searchText}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  getSearchItems();
                }
              }}
              onChange={handleSearch}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <SearchIcon className="gray-clr" />
                  </InputAdornment>
                ),
              }}
            />
          )}
          {loading && <Loader loading={loading} />}
          <Stack spacing={1}>
            {searchItems.map((item, i) => {
              return (
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid grey",
                    pb: 1,
                  }}
                >
                  <Typography>{item.name}</Typography>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={() => onSelect(item)}
                  >
                    Select
                  </Button>
                </Box>
              );
            })}
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default SearchItems;
